import { render, staticRenderFns } from "./CandidateListAddFreePool.vue?vue&type=template&id=628d5fc0&"
import script from "./CandidateListAddFreePool.vue?vue&type=script&lang=js&"
export * from "./CandidateListAddFreePool.vue?vue&type=script&lang=js&"
import style0 from "./CandidateListAddFreePool.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports